<div class="insurance-status"
     [ngClass]="value$ | async"
>
  {{ label$ | async}}
</div>
